export const debounce = (func, delay = 500, self = this) => {
  let setTimoutInstance
  return (...args) => {
    if (setTimoutInstance) clearTimeout(setTimoutInstance)
    setTimoutInstance = setTimeout(() => func.apply(self, args), delay)
  }
}
